import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { authentication } from './authentication.module';
import { profiles } from './profiles.module';
import { status } from './status.module';
import { country } from './country.module';
import { state } from './state.module';
import { customer } from './customer.module';
import { location } from './location.module';
import { actions } from './action.module';
import { tabwatchertimer } from './tabwatchertimer.module';
import { loading } from './loading.module';
import { document } from "./document.module";
import { config } from "./changeconfig.module"
import { userLocations} from "@/_store/userlocations.module";
import { userCustomers} from "@/_store/usercustomers.module";

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        actions,
        alert,
        authentication,
        profiles,
        status,
        country,
        state,
        customer,
        location,
        tabwatchertimer,
        loading,
        document,
        config,
        userLocations,
        userCustomers
    }
});

